/* Meltiva preference reveal: presentation-only, never alters pricing or checkout. */
(function(){
  'use strict';
  const copy = {
    results: 'You care about results, so consistency matters. Meltiva’s quick-dissolving strips make your supplement routine easy to follow. Explore your options below.',
    value: 'You care about value, so a practical routine matters. Meltiva offers a convenient, portable supplement format. See the available options and prices below.'
  };

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-meltiva-choice], [data-choice-reset]');
    if(!button) return;
    const gate = button.closest('[data-meltiva-choice-gate]');
    if(!gate) return;

    const question = gate.querySelector('[data-choice-question]');
    const answer = gate.querySelector('[data-choice-answer]');
    const label = gate.querySelector('[data-choice-answer-text]');
    if(!question || !answer || !label) return;

    if(button.hasAttribute('data-choice-reset')) {
      gate.classList.remove('is-revealed');
      answer.hidden = true;
      question.hidden = false;
      const first = gate.querySelector('[data-meltiva-choice]');
      if(first) first.focus({preventScroll:true});
      return;
    }

    const selection = button.getAttribute('data-meltiva-choice');
    if(!Object.prototype.hasOwnProperty.call(copy,selection)) return;
    label.textContent = copy[selection];
    gate.dataset.selectedPriority = selection;
    gate.classList.add('is-revealed');
    question.hidden = true;
    answer.hidden = false;
    const change = gate.querySelector('[data-choice-reset]');
    if(change) change.focus({preventScroll:true});
    gate.dispatchEvent(new CustomEvent('meltiva:priority-selected', {
      bubbles:true, detail:{priority:selection}
    }));
  });
})();
